import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgCheckCircleMid } from './svg/check-circle-mid.svg.js';

/**
 * @deprecated - use CheckCircle.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
const CheckCircleMid = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { title, size: _size, legacyBoundingBox: _legacyBoundingBox, ...rest } = props;
    return (jsx(SvgCheckCircleMid, { viewBox: "-1.33 -1.33 26.66 26.66", "aria-label": title, role: "img", ...rest, width: 24, height: 24, "data-pp-icon": "CheckCircleMid" }));
};

export { CheckCircleMid as default };
//# sourceMappingURL=CheckCircleMid.js.map
